import { getConfig } from '@testing-library/dom';

function eventWrapper(cb) {
    let result;
    getConfig().eventWrapper(()=>{
        result = cb();
    });
    return result;
}

export { eventWrapper };
